import { AuditOverview } from '@/audit/AuditOverview'

export function Audit() {
  return <AuditOverview />
}
